module.exports = __webpack_public_path__ + "img/ivana-square.a1900888.jpg";